import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { useParams } from 'react-router-dom';

import ProgressIndicator from '../../Common/ProgressIndicator';
import ErrorIndicator from '../../Common/ErrorIndicator';
import TaskRegistrationEditForm from './TaskRegistrationEditForm';

function TaskRegistrationEditPage(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [taskReg, setTaskReg] = useState(null);
    const { eventId, taskId, taskRegId } = useParams();

    useEffect(() => {
        setIsLoading(true);
        Axios.get(`/admin/events/${eventId}/tasks/${taskId}/registrations/${taskRegId}`).then(res => {
            setTaskReg(res);
            setIsLoading(false);
        }, err => {
            setIsLoading(false);
            setError(true);
        });
    }, [eventId, taskId, taskRegId]);

    if (isLoading)
        return <ProgressIndicator />;

    if (error)
        return <ErrorIndicator text="A feladat-jelentkezés letöltése sikertelen." />;

    if (taskReg)
        return (
            <>
                <h1>Feladat-jelentkezés szerkesztése</h1>
                <TaskRegistrationEditForm taskReg={taskReg} />
            </>
        );

    return null;
}

export default TaskRegistrationEditPage;